import React, { FC, ReactNode, createContext, useContext } from 'react'

const PathContext = createContext<string>('/')

//* null only outside Gatsby's page tree (unit tests); wrapPageElement always provides it.
const PagePathContext = createContext<string | null>(null)

type PathProviderProps = {
  pathname: string
  /** The path the page was built at — see usePagePath. Defaults to `pathname`. */
  pagePath?: string
  children: ReactNode
}

export const PathProvider: FC<PathProviderProps> = ({ pathname, pagePath, children }) => (
  <PathContext.Provider value={pathname}>
    <PagePathContext.Provider value={pagePath ?? pathname}>{children}</PagePathContext.Provider>
  </PathContext.Provider>
)

/**
 * The path this page was BUILT at, identical on the server and in the browser. Use it for URLs
 * that identify the page (canonical, og:url). In the browser `location.pathname` is whatever URL
 * was requested instead — e.g. `/blog/AI/…`, which the CDN serves with the `/blog/ai/…` page — and
 * on the server Gatsby's `path` page prop is the router pattern `/*`, not the page.
 */
export const usePagePath = (): string | null => useContext(PagePathContext)

export const isChinaPath = (pathname: string): boolean =>
  pathname === '/cn' || pathname.startsWith('/cn/')

export const useIsChinaSite = (): boolean => {
  const pathname = useContext(PathContext)
  return isChinaPath(pathname)
}

export default PathContext
